var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11 11",
    style: {
      enableBackground: "new 0 0 11 11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.7212257,9.3755007L8.5353823,7.1896644H7.4678612 c0.7252884-0.7935233,1.1267672-1.8114839,1.1267672-2.893477c0-1.1481156-0.4472027-2.2276459-1.2590833-3.0393379 c-1.6758037-1.6757994-4.4028883-1.6757994-6.0786924,0s-1.6758039,4.4026909,0,6.0786762 c0.8379018,0.8379002,1.9386241,1.2568493,3.039346,1.2568493c1.0391994,0,2.0755405-0.3782902,2.8935776-1.1251373v1.0682154 l2.185751,2.1857433C9.5613976,10.9070654,9.8048868,11,10.048377,11c0.2434893,0,0.4869795-0.0929346,0.6728487-0.2788038 C11.0929661,10.3494568,11.0929661,9.7472391,10.7212257,9.3755007z M2.0642722,6.5281086 c-1.2304595-1.2308278-1.2304595-3.2332001,0-4.4638419c0.6152296-0.6152281,1.4237642-0.9228421,2.2319267-0.9228421 s1.6166973,0.3076141,2.2319269,0.9228421c0.596271,0.5962694,0.9245176,1.3888168,0.9245176,2.2319207 S7.1243968,5.931839,6.5281258,6.5279226C5.2976665,7.7589364,3.2947314,7.7585645,2.0642722,6.5281086z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.6b5eb785f6e7c501439d8e5d96b1579d.svg";
export { ForwardRef as ReactComponent };